// extracted by mini-css-extract-plugin
module.exports = {"reasonContainer":"reasonDropdown__reasonContainer___2QFhj","reasonLabel":"reasonDropdown__reasonLabel___3LzkO","reason":"reasonDropdown__reason___1ToDt"};